export default __webpack_public_path__ + "314b038af255ebf5ed780c0633021f0b.png";